import { useCallback } from 'react';

import { useTracking } from '@change-corgi/core-react/tracking';

import {
	useContributionsPageData,
	useContributionsPageState,
} from '#src/app/pages/accountSettings/contributions/main/pageContext';

type Result = ModelHookResult<
	{
		i18nSuffix: string;
		showUpsell: boolean;
	},
	{
		cancelSubscription: () => void;
	}
>;

export function useStopContributions(): Result {
	const track = useTracking();
	const {
		data: {
			featureConfigs: { shouldUseDonationLanguage },
			subscription: {
				config: { minimumAmount },
			},
		},
	} = useContributionsPageData();
	const [
		{
			subscription: { amount },
		},
		{ resetPageMessage },
	] = useContributionsPageState();

	return {
		data: {
			i18nSuffix: shouldUseDonationLanguage ? '_donation' : '',
			showUpsell: amount > minimumAmount,
		},
		actions: {
			cancelSubscription: useCallback(() => {
				void track('subs_cancel_modal_view');
				resetPageMessage();
			}, [resetPageMessage, track]),
		},
	};
}
